import React from 'react';
import { FadeIn } from './FadeIn';
export function TheTomes() {
  const tomes = [{
    dot: '🟢',
    title: 'Tomo 1 — El Año Resuelto',
    desc: 'Planificación anual completa · Currículum por nivel · 4 niveles definidos · Filosofía pedagógica · Sistema de hitos · La estructura completa del año pianístico'
  }, {
    dot: '🟡',
    title: 'Tomo 2 — Pequeños Pianistas',
    desc: 'Iniciación lúdica para chicos de 4-8 años · Mundo Pianilandia con personajes · Cuento-método de 36 micro-clases · 120 flashcards organizadas en 6 categorías · Pre-lectura musical'
  }, {
    dot: '🟠',
    title: 'Tomo 3 — Teoría que se Juega',
    desc: '40+ ideas de juegos para enseñar teoría sin que aburra · Animales del ritmo · Lectura de notas · Intervalos · Escalas · Dictado · La teoría que se descubre, no se explica'
  }, {
    dot: '🔴',
    title: 'Tomo 4 — Repertorio Listo',
    desc: 'Sistema para curar y elegir repertorio · Lo legal y dominio público · Adaptación de piezas a 4 niveles · Mapa "si le gustó X, dale Y" · Banco propio de partituras · Conversación de pieza soñada'
  }, {
    dot: '🟣',
    title: 'Tomo 5 — Manos que Vuelan',
    desc: 'Técnica pianística sin tensión · Postura, peso y relajación · 4 ejercicios de independencia de dedos · Pasaje del pulgar · Práctica diaria sistemática · Memorización en 4 capas'
  }, {
    dot: '⭐',
    title: 'Tomo 6 — El Gran Concierto',
    desc: 'Evaluación continua + ronda de logros trimestral · Planificación completa del recital de fin de año · Comunicación con familias y padres difíciles · Construcción de comunidad'
  }];
  const includes = ['Planificación lista para usar', 'Capítulos con estrategias concretas', 'Criterios de progresión por nivel y edad', 'Sistema de evaluación trimestral', 'Errores frecuentes y cómo evitarlos', 'Conexión con los otros tomos', 'Material original Piano Listo®', '100% adaptado al profe de piano argentino'];
  return <section className="bg-cream py-16 md:py-20 text-navy-900" data-id="element-296">
      <div className="container mx-auto px-4 sm:px-6" data-id="element-297">
        <FadeIn className="text-center mb-10" data-id="element-298">
          <h2 className="font-display font-bold text-3xl md:text-4xl mb-2" data-id="element-299">
            Lo que <span className="text-gold-dark" data-id="element-300">recibís</span>
          </h2>
          <h3 className="font-display font-bold text-xl md:text-2xl text-primaryBlue mb-2" data-id="element-301">
            🎹 LOS 6 TOMOS
          </h3>
          <p className="font-accent italic text-base md:text-lg text-gray-600" data-id="element-302">
            Para profesores de piano de todos los niveles
          </p>
        </FadeIn>

        {/* Compact list layout — like the reference */}
        <FadeIn delay={0.1} data-id="element-303">
          <div className="max-w-2xl mx-auto bg-warmWhite border border-gold/20 rounded-2xl p-5 sm:p-8 mb-12 shadow-sm" data-id="element-304">
            <div className="space-y-5" data-id="element-305">
              {tomes.map((tome, i) => <div key={i} className="flex items-start gap-3" data-id="element-306">
                  <span className="text-lg shrink-0 mt-0.5" data-id="element-307">{tome.dot}</span>
                  <div data-id="element-308">
                    <span className="font-bold text-navy-800 text-sm sm:text-base" data-id="element-309">
                      {tome.title}
                    </span>{' '}
                    <span className="text-gray-500 text-sm leading-relaxed" data-id="element-310">
                      {tome.desc}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-311">
          <div className="max-w-2xl mx-auto bg-warmWhite border border-gold p-6 sm:p-8 rounded-xl shadow-lg relative overflow-hidden" data-id="element-312">
            <div className="absolute top-0 left-0 w-1 h-full bg-gold" data-id="element-313"></div>
            <h4 className="font-bold text-lg text-navy-900 mb-5 border-b border-gray-200 pb-3" data-id="element-314">
              Cada tomo incluye:
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-6" data-id="element-315">
              {includes.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-316">
                  <span className="text-success shrink-0 text-sm" data-id="element-317">✅</span>
                  <span className="text-gray-700 font-medium text-sm" data-id="element-318">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}